export function formatFullName(lastName: string, firstName: string, middleInitial?: string) {
  const lastNameTrimmed = lastName ? lastName.trim() : '';
  const firstNameTrimmed = firstName ? firstName.trim() : '';
  const middleInitialTrimmed = middleInitial ? middleInitial.trim() : '';
  let label = '';
  if (lastNameTrimmed && firstNameTrimmed) {
      label = `${lastNameTrimmed}, ${firstNameTrimmed}${middleInitialTrimmed ? ' ' + middleInitialTrimmed : ''}`;
  } else if (lastNameTrimmed) {
      label = lastNameTrimmed;
  } else if (firstNameTrimmed) {
      label = `${firstNameTrimmed}${middleInitialTrimmed ? ' ' + middleInitialTrimmed : ''}`;
  } else if (middleInitialTrimmed) {
      label = middleInitialTrimmed;
  }
  return label.trim();
}

export function capitalizeFirstLetter(string: string) {
  return string.replace(/^./, string[0].toUpperCase());
}

export function dataidGenerator(str: string) {
  str = String(str);
  str = str.replace(/[^a-zA-Z0-9 ]/g, "");
  str = str.replace(/\W/g, "-");
  return str.toLowerCase();
}

export const isValidEmail = (email: string): boolean => {  
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);     
}

export const formatContentWithLinks = (content: string): string => {
  if (!content) return '';
  
  // Process the content with our custom tags
  let processedContent = content;
  
  // Step 1: Handle highlighted links (<hl>text</hl><link>url</link>)
  processedContent = processedContent.replace(
    /<hl>(.*?)<\/hl><link>(.*?)<\/link>/g, 
    '<a href="$2" style="color: #196ecf !important; font-weight: 600 !important;" class="!text-[#196ecf] font-semibold hover:underline" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  
  // Step 2: Handle any remaining highlighted text
  processedContent = processedContent.replace(
    /<hl>(.*?)<\/hl>/g, 
    '<span style="color: #196ecf !important; font-weight: 600 !important;" class="!text-[#196ecf] font-semibold">$1</span>'
  );
  
  // Step 3: Handle remaining standalone links
  processedContent = processedContent.replace(
    /<link>(.*?)<\/link>/g, 
    '<a href="$1" style="color: #196ecf !important;" class="!text-[#196ecf] hover:underline" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  
  // Handle bold text tags
  processedContent = processedContent.replace(
    /<bold>(.*?)<\/bold>/g,
    '<strong>$1</strong>'
  );
  
  // Handle bullet points with pipe delimiter
  processedContent = processedContent.replace(
    /<bullet>([\s\S]*?)<\/bullet>/g,
    (match, bulletContent) => {
      // Split by pipe character and trim each item
      const items: string[] = bulletContent.split('|').map((item: string) => item.trim());
      
      // Create HTML unordered list
      return '<ul style="list-style-type: disc; padding-left: 20px;">' +
        items.map(item => `<li>${item}</li>`).join('') +
        '</ul>';
    }
  );
  
  // Step 4: Handle line breaks with list items (<lb>)
  processedContent = processedContent.replace(
    /<lb>/g, 
    '<br>'
  );
  
  // Step 5: Instead of double <br>, wrap content in paragraphs
  const paragraphs = processedContent.split(/<br>/g);
  const filteredParagraphs = paragraphs
    .map(p => p.trim())
    .filter(p => p !== ''); // Remove empty paragraphs
  
  // Apply margin to all paragraphs except the last one
  processedContent = filteredParagraphs.map((p, index) => {
    const isLastParagraph = index === filteredParagraphs.length - 1;
    return `<p>${p}</p>`;
  }).join('');
  
  // Step 6: Handle any plain URLs in text
  const urlRegex = /(?<!href="|">)(https?:\/\/[^\s<]+)(?![^<]*<\/a>)/g;
  processedContent = processedContent.replace(
    urlRegex,
    '<a href="$1" style="color: #196ecf !important;" class="!text-[#196ecf] hover:underline" target="_blank" rel="noopener noreferrer">$1</a>'
  );
  
  return processedContent;
};